import { differenceWith, fromPairs, isEqual, toPairs } from 'lodash'

export const objectDiff = (a: any, b: any) => fromPairs(differenceWith(toPairs(a), toPairs(b), isEqual))
